import { createSelector } from '@ngrx/store';
import { cartState } from '../../../cart/selectors/root';
import { getProductSizeOptions } from '../../../ingredients/selectors/getProductSizeOptions/get-product-size-options.selector';

export const getCartSimpleItemQuantity = (productId: number, virtualLocationNo: Nullable<number> = null) =>
    createSelector(cartState, getProductSizeOptions(productId), (cart, productSizeOptions) =>
        cart.itemsSimple.reduce((acc, curr) => {
            const isItItemOrItsSizeOption = curr.ProductId === productId || productSizeOptions?.some((item) => item.ProductId === curr.ProductId);

            if (isItItemOrItsSizeOption && curr.VirtualLocationNo === virtualLocationNo) {
                return (acc += curr.Quantity);
            }

            return acc;
        }, 0),
    );
